// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clickable-text {
  color: #007bff; /* Link color */
  cursor: pointer; /* Pointer cursor on hover */
  text-decoration: underline; /* Underline text */
}

.clickable-text:hover {
  color: #0056b3; /* Darker shade on hover */
}

/* Ensure AI action links wrap and don't overlap */
.commonlintbtn-parent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.mat-badge-content {
  background: #5ea1d8;
}

.fileExplorer {
  margin-bottom: 0px;
}
.fileExplorer input {
  margin-bottom: 0px;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 20px !important;
  width: 90%;
  max-width: 600px;
  max-height: 600px;
  overflow-y: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid #ddd;
}
.main-div .main-content .top-head {
  font-size: 22px !important;
  text-align: center;
  padding: 10px;
}

.font16 {
  font-size: 16px !important;
  font-family: "Raleway";
}

.btn-primary {
  background-color: #5ea1d8;
  border: none;
}

.flowbycat {
  background-color: transparent;
}

.hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}

textarea {
  color: rgba(0, 0, 0, 0.54) !important;
}

.img-and-video-sec {
  border-radius: 5px;
  max-height: 300px !important;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px !important;
  border: 1px solid lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}
.img-and-video-sec video {
  min-height: 274px !important;
}
.img-and-video-sec img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.img-and-video-sec video.video-display {
  max-width: 100%;
  max-height: 250px;
}
.img-and-video-sec p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}

/* Prevent label/counter overlaps and tighten mobile UI */
@media (max-width: 460px) {
  h3 {
    font-size: 16px !important;
  }
  .font16 {
    font-size: 12px !important;
  }
  /* Quill toolbar buttons wrap rather than overlap */
  .ql-toolbar .ql-formats {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 2px;
  }
  /* Make hints occupy their own row to avoid collisions */
  mat-form-field .mat-hint {
    display: block;
    width: 100%;
    margin-top: 4px;
  }
  /* Long filenames/URLs wrap */
  .file-details, .top-head {
    word-break: break-word;
    white-space: normal;
  }
  .fileExplorer.btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    font-size: 12px;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div {
    min-height: 92vh;
  }
  .main-content {
    width: 75%;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .img-and-video-sec {
    min-height: unset !important;
    max-height: unset !important;
    padding: 30px !important;
  }
  .main-div .img-and-video-sec img.img-display {
    max-height: 100px;
  }
  .main-div .img-and-video-sec .video-display {
    max-height: 100px;
    min-height: 144px !important;
  }
}
.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: -69px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

.cam-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
}

:host-context(body.theme-dark) .main-div {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .main-content {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  color: #e5e7eb !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/steps/steps.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA,EAAA,eAAA;EACA,eAAA,EAAA,4BAAA;EACA,0BAAA,EAAA,mBAAA;AACF;;AAEA;EACE,cAAA,EAAA,0BAAA;AACF;;AAEA,kDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,kBAAA;AAEF;AADE;EACE,kBAAA;AAGJ;;AAAA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAEJ;AADI;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;AAGN;AASI;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;AAPN;;AAaA;EAAS,0BAAA;EAA2B,sBAAA;AARpC;;AASA;EAAc,yBAAA;EAA0B,YAAA;AAJxC;;AAKA;EAAW,6BAAA;AADX;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AACF;;AACA;EACE,qCAAA;AAEF;;AAAA;EACE,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAGF;AAFE;EACE,4BAAA;AAIJ;AAFE;EAME,eAAA;EACA,iBAAA;EACA,mBAAA;AADJ;AAGE;EAAqB,eAAA;EAAiB,iBAAA;AACxC;AAAE;EAAE,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AAGJ;;AAAA,yDAAA;AACA;EACE;IAAK,0BAAA;EAIL;EAHA;IAAU,0BAAA;EAMV;EAJA,mDAAA;EACA;IACE,oBAAA;IACA,eAAA;IACA,QAAA;EAMF;EAHA,wDAAA;EACA;IACE,cAAA;IACA,WAAA;IACA,eAAA;EAKF;EAFA,6BAAA;EACA;IACE,sBAAA;IACA,mBAAA;EAIF;EADA;IACE,oBAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;IACA,eAAA;EAGF;AACF;AAAA;EACE;IACE,gBAAA;EAEF;EAAA;IACE,UAAA;EAEF;AACF;AACA;EACE;IACE,2BAAA;EACF;EAAE;IACE,mCAAA;IACA,wBAAA;EAEJ;AACF;AAEA;EAEI;IAAoB,4BAAA;IAA8B,4BAAA;IAChD,wBAAA;EACJ;EAAI;IACE,iBAAA;EAEN;EAAI;IACE,iBAAA;IACA,4BAAA;EAEN;AACF;AAMA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAJF;;AAMA;EAGE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,qBAAA;AANF;AAQA;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AANF;;AAUE;EACE,mBAAA;EACA,cAAA;AAPJ;AASE;EACE,WAAA;AAPJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAPF;;AAWE;EACE,8BAAA;EACA,yBAAA;AARJ;AAWE;EACE,8BAAA;EACA,iDAAA;EACA,yBAAA;EACA,mDAAA;AATJ","sourcesContent":[".clickable-text {\n  color: #007bff; /* Link color */\n  cursor: pointer; /* Pointer cursor on hover */\n  text-decoration: underline; /* Underline text */\n}\n\n.clickable-text:hover {\n  color: #0056b3; /* Darker shade on hover */\n}\n\n/* Ensure AI action links wrap and don't overlap */\n.commonlintbtn-parent {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.mat-badge-content {\n  background:#5ea1d8;\n}\n.fileExplorer{\n  margin-bottom: 0px;\n  input{\n    margin-bottom: 0px;\n  }\n}\n.main-div{\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 89vh;\n    background: #efeeee !important;\n    .main-content{\n      border-radius: 10px 10px 10px 10px;\n      background: #fff;\n      padding: 20px 20px !important;\n      width: 90%;\n      max-width: 600px;\n      max-height:600px;\n      overflow-y:auto;\n      width: 100%;\n      position: relative;\n      padding: 0px;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      text-align: center;\n      border: 1px solid #ddd;\n      // &::-webkit-scrollbar {\n      //   width: 4px;\n      //   height: 100px;\n      // }\n      // &::-webkit-scrollbar-track {\n      //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n      // }\n      // &::-webkit-scrollbar-thumb {\n      //   background-color: #5ea1d8;\n      //   outline: 1px solid #5ea1d8;\n      // }\n    .top-head {\n      font-size: 22px !important;\n      text-align: center;\n      padding: 10px;\n    }\n\n  }\n}\n\n.font16 {font-size: 16px!important; font-family:\"Raleway\";}\n.btn-primary {background-color:#5ea1d8; border: none;}\n.flowbycat{background-color: transparent;}\n.hide_file {\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  cursor: pointer;\n  right: 0;\n  top: 0;\n  height: 100%;\n  font-size: 24px;\n  width: 100%;\n}\ntextarea{\n  color:rgba(0, 0, 0, 0.54) !important;\n}\n.img-and-video-sec{\n  border-radius: 5px;\n  max-height: 300px !important;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  min-height: 300px !important;\n  border: 1px solid lightgray;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  video{\n    min-height: 274px !important;\n  }\n  img.img-display {\n  //  position: absolute;\n  //  top: 0;\n  //  left: 0;\n  //  right: 0;\n  //  bottom: 0;\n    max-width: 100%;\n    max-height: 250px;\n    object-fit: contain;\n  }\n  video.video-display {max-width: 100%; max-height: 250px;}\n  p{color: rgba(0, 0, 0, 0.54) !important;\n    text-align: left !important;\n    padding: 10px;\n    line-height: 20px;}\n}\n\n/* Prevent label/counter overlaps and tighten mobile UI */\n@media(max-width:460px){\n  h3 { font-size: 16px !important; }\n  .font16 { font-size: 12px !important; }\n\n  /* Quill toolbar buttons wrap rather than overlap */\n  .ql-toolbar .ql-formats {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 2px;\n  }\n\n  /* Make hints occupy their own row to avoid collisions */\n  mat-form-field .mat-hint {\n    display: block;\n    width: 100%;\n    margin-top: 4px;\n  }\n\n  /* Long filenames/URLs wrap */\n  .file-details, .top-head { \n    word-break: break-word; \n    white-space: normal;\n  }\n\n  .fileExplorer.btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px){\n  .main-div{\n    min-height:92vh;\n  }\n  .main-content{\n    width:75%;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px){\n  .main-div{\n    background:#fff !important;\n    .main-content{\n      width:calc(100% - 30px) !important;\n      padding: 20px !important;\n    }\n  }\n\n}\n@media(max-width:460px){\n  .main-div{\n    .img-and-video-sec {min-height: unset !important; max-height: unset !important;\n      padding: 30px !important;\n      img.img-display{\n        max-height:100px;\n      }\n      .video-display{\n        max-height:100px;\n        min-height: 144px !important;\n        // margin-top: 30px !important;\n      }\n    }\n  }\n}\n\n\n\n.img-div-left{\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.img-div-left.small-spinner{\n \n   \n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n \n  top: -69px !important;\n\nimg{\n  width:100px !important;\n  height:100px !important;\n  top:unset !important;\n}\n}\n.quill-wrapper{\n  .fl-left{\n    margin-bottom: 10px;\n    display: block;\n  }\n  quill-editor{\n    width: 100%;\n  }\n}\n.cam-icon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n:host-context(body.theme-dark) {\n  .main-div {\n    background: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  .main-content {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    color: #e5e7eb !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
